import React from "react";
import { useTranslation } from "react-i18next";
import style from "./CargoComment.module.scss";

const CargoComment = ({ comment }) => {
  const { t } = useTranslation();

  return (
    <div className={style.card}>
      <div className={style.topbar}>
        <span className={style.title}>{t("orderInfoExpeditor.cargoComment.title")}</span>
      </div>
      <p className={comment ? style.text : style.text_empty}>
        {comment || t("orderInfoExpeditor.cargoComment.noComment")}
      </p>
    </div>
  );
};

export default CargoComment;
